export const getEnv = (key: string): string | undefined => {
  // Vite injects import.meta.env at build time
  return (import.meta.env as Record<string, string>)?.[key];
};
